
const state = {
    utilityContext: {
        returnMessage: null
    }
};

const getters = {
    getUtilityContext: (state) => state.utilityContext,
    getReturnMessage: (state) => state.utilityContext.returnMessage
};

const actions = {
    raiseMessage({commit}, message){
        commit('raiseUtilityStateMessage', message);
    },
    dismissMessage({commit}){
        commit('dismissUtilityStateMessage');
    }
};

const mutations = {
    raiseUtilityStateMessage(state, message){
        state.utilityContext.returnMessage = message;
    },
    
    dismissUtilityStateMessage(state){
        state.utilityContext.returnMessage = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};